import Hero from "../designSystem/Hero";
// import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import MortgageRepaymentCalculator from "./calculators/MortgageRepaymentCalculator";
import SEO from "../designSystem/SEO";

const MortgageRepaymentCalculatorsPage = () => {
  return (
    <div>
      <SEO
        title="Mortgage Repayment Calculator"
        description="Estimate monthly mortgage repayments using your property price, deposit, mortgage term and interest rate with Monk Financial Planning."
        path="/calculators/mortgage-repayment"
      />
       <Hero
                //         title={`Financial Clarity
                // Direction & Confidence`}
                //         subtitle="Wealth Management Solutions"
                showOverlay={true}
                // backgroundImage={HeroBackground}
                titleAlign="center"
                subtitleAlign="center"
                pageTitle="Calculators"
                title="Mortgage Repayment"
                subtitle="
      Understanding what your mortgage repayments could look like can help you plan your finances with greater confidence. Our Mortgage Repayment Calculator gives you an indication of your potential monthly repayments based on your mortgage amount, interest rate and term, helping you understand how different options could affect your budget."
                showButton={true}
                textAlign="center"
              ></Hero>
      <MortgageRepaymentCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default MortgageRepaymentCalculatorsPage;
